import React from 'react'

export default function Scale({ scale }) {
	return (
		<div>
			{scale
				? scale.map((color) => {
						return (
							<p
								key={color}
								className="w-24 h-10"
								style={{ backgroundColor: color }}
							></p>
						)
				  })
				: null}
		</div>
	)
}
